import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cb52124"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Back to map!")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_row = _resolveComponent("van-row")!
  const _component_FriendCell = _resolveComponent("FriendCell")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_button = _resolveComponent("van-button")!
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "drawer",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleBottomSheet && _ctx.toggleBottomSheet(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, {
        ref: "infoBox",
        class: "message-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.gem.message), 1)
        ]),
        _: 1
      }, 512),
      (!_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_FriendCell, {
              key: _ctx.friend.id,
              friend: _ctx.friend,
              isClickable: true,
              shouldDisplayUsername: true
            }, null, 8, ["friend"]),
            _createVNode(_component_van_row, { class: "message-details content" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.MapIcon,
                  id: "icon"
                }, null, 8, _hoisted_3),
                _createVNode(_component_van_col, { span: "19" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.gemAddress), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_van_row, { class: "message-details content" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.CalendarIcon,
                  id: "icon"
                }, null, 8, _hoisted_4),
                _createVNode(_component_van_col, { span: "19" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.displayDropDateTime), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_van_button, { onClick: _ctx.backToHome }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [
      _directive_touch,
      _ctx.swipeBottomSheetUp,
      "swipe",
      { top: true }
    ],
    [
      _directive_touch,
      _ctx.swipeBottomSheetDown,
      "swipe",
      { bottom: true }
    ]
  ])
}